export default __webpack_public_path__ + "static/1262-af59130606fe21c7a40c2b858a3bb63e.gif";